const translateErrpr = (e, lang) => {
  const errors = {
    de: {
      "Email address is already in use.": "E-Mail bereits verwendet",
      "IBAN already used": "IBAN bereits verwendet",
      "Incorrect username or password. Please try again.": "falsche Email oder Passwort"
    }
  }
  return errors[lang][e]
}
export default {
  methods: {
    goToPage: (pageName, self) => {
      // console.log("gotopage::->", pageName)
      self.$eventHub.$emit('goToPage-event', pageName);
      console.log("Employe ", pageName)
      if (pageName == 'employee-page') {
        self.$store.commit('setUserType', 'employee')
      } else if (pageName == 'partner-page') {
        self.$store.commit('setUserType', 'partner')
      }

      // change url when moving to another page
      if (location.pathname.split('/').join('') !== pageName) {
        history.replaceState({}, null, '/' + pageName)
      }
    },
    sendProductPhotos:(params,buttonComponent)=>{
      let fieldId = params;
      // console.log("1. will SEND products:::", fieldId, buttonComponent)

      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));

      buttonComponent.$eventHub.$emit('sendProductPhotos-event', fieldId);
    },
    sendForm: (params, buttonComponent) => {
      if (params.indexOf(',') > -1) {
        params = params.split(',')
      }
      let formId = params;
      let neuStarTrigger = false
      if (self._.isArray(params)) {
        formId = params[0]
        neuStarTrigger = params.filter(param => param === 'neuStarTrigger')
        // console.log("1. will SEND FORM:::", formId, 'neuStarTrigger', neuStarTrigger.length > 0)
      }
      const triggers = {
        neuStarTrigger: neuStarTrigger.length > 0
      }
      // console.log("1. will SEND FORM:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      // console.log("2. will SEND FORM:::", formId, buttonComponent)

      buttonComponent.$eventHub.$emit('getFormData-event', formId, triggers, buttonComponent);
    },
    sendProducts: (formId, buttonComponent) => {
      // console.log("SEND PRODUCTS:::", formId)
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.$emit('sendProducts-event', formId);
    },
    getCustomerToken: (params, self) => {
      // console.log("getCustomerToken", self)
      self.$store.dispatch('retrieveUserToken')
    },
    doneTrigger: (component, eventResult) => {
      component.$eventHub.$off('done-event-trigger');
      component.loading = false
      // console.log('1. will Done Trigger', eventResult)
      // console.log('event Result',eventResult)
      if (eventResult.status) {
        eventResult.parent.clear()
      }
      if (!eventResult.status && eventResult.message) {
        // console.log("EVENT RESULT>>>", eventResult)
        // const lang = "de"

        // Oops. Something went wrong, please try again later.
        // const defaultErrorMessage = "Hoppla. Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
        // if (eventResult.invalid_fields && eventResult.invalid_fields.length) {
        //     const localErr = translateErrpr(eventResult.invalid_fields[0], lang)
        //     if (localErr) component.showModal(localErr)
        //     else component.showModal(defaultErrorMessage)
        //     return
        // }
        component.showModal(eventResult.message)
      }

    },
    sendReceipt: (component, buttonComponent)=>{
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$emit('sendReceipt-event', buttonComponent)
    },
    sendSurvey: (params, buttonComponent) => {
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$emit('sendSurvey', params)
      buttonComponent.$eventHub.$emit('sendReceipt-event', buttonComponent)
    }
  }
}